import { Location } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "city-tax-back-link",
  templateUrl: "./back-link.component.html",
  styleUrls: ["./back-link.component.scss"]
})
export class BackLinkComponent {
  @Input() ariaLabel = "Go back";
  @Input() buttonClass = "text-primary d-flex align-items-center bg-transparent border-0 p-0";
  @Input() iconClass = "icon btn-primary mr-3";

  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
